module.exports = __webpack_public_path__ + "public/Icons/homeSliderPrev.png?4cf01bc2";